var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-snotify'),(_vm.$route.meta.showNavigation)?_c('HomeHeader'):_vm._e(),_c('div',{staticClass:"main",attrs:{"id":"main"}},[_c('router-view')],1),_c('CitizenGate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }